export default __webpack_public_path__ + "static/media/connectWithGithub.c0cda32f.svg";